import { Avatar, Box } from '@mui/material'
import { useAuth } from 'contexts/auth'
import { IProjectDTO } from 'data/dtos/automation/i-project-dto'
import { SyntheticEvent, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import useContract from 'store/contracts'
import { formatCNPJ } from 'utils/is-valid-cnpj'
import { stringToAvatar } from 'utils/string-to-avatar'
import ContractStatus from '../../status'
import { useStyles } from './styles'

interface IRouteParams {
  organizationId: string
  contractId: string
  tagId: string
}

interface ContractsHeaderProps {
  project: IProjectDTO
}

const ContractViewHeader = ({ project }: ContractsHeaderProps) => {
  const { actualOrganization, updateTab, updateContractTagName, contractTagName } = useContract()
  const { contractId } = useParams<IRouteParams>()
  const { user } = useAuth()

  const classes = useStyles()

  const handleChangeTab = (_: SyntheticEvent, newValue: number) => updateTab(newValue)

  const tabOptions = ['Contratos', 'Ferramentas']

  useEffect(() => {
    updateContractTagName(project.tags[0])
  }, [])

  return (
    <Box className={classes.root}>
      <Box className={classes.containerBase}>
        <section>
          <span className={classes.title}>Cliente</span>
          <div className={classes.containerInfo}>
            <Avatar {...stringToAvatar(actualOrganization.name, '#BDBDBD')} />

            <Box className={classes.groupText}>
              <span style={{ fontWeight: 600 }}>{actualOrganization.name}</span>
              <span className={classes.subTitle}>{formatCNPJ(actualOrganization.federalTaxId, false)}</span>
            </Box>

            <ContractStatus status='active' />
          </div>
        </section>

        <section>
          <span className={classes.title}>Contrato</span>
          <h3 className={classes.content}>{project.contractName}</h3>
        </section>
      </Box>
    </Box>
  )
}

export default ContractViewHeader
